import React from 'react';

import Question from './Question';

import classes from './Topic.module.scss';

const Topic = ({ questions }) => (
  <div className={classes.topic}>
    {questions.map((item, index) => (
      <Question key={item.question} index={index} question={item} />
    ))}
  </div>
);

export default Topic;
